import { Button, Text, Box, Input } from "@chakra-ui/react"
import WithAuth from "../components/hoc/with-auth"
import { AuthLayout } from "../components/layouts"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx"
import DealsPage from "../components/pages/deals-page"
import OpenPositionsPage from "../components/pages/open-positions"

const OpenPositions = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Open Positions"
          pageDesc="List of all the current open positions"
        >
          <OpenPositionsPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default OpenPositions
